// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__mFcCx","buttons":"PendingPaymentAlert_buttons__iatX5"};